"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Figure;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactUseIdHook = require("react-use-id-hook");

var _Image = _interopRequireDefault(require("../Image/Image"));

var _util = require("../util");

require("./Figure.css");

var _excluded = ["caption", "srCaption", "topCaption", "photoCredit", "className", "alt", "longAlt", "children", "width", "height", "figStyle", "imgStyle", "capStyle", "src"];

function Figure(_ref) {
  var caption = _ref.caption,
      srCaption = _ref.srCaption,
      topCaption = _ref.topCaption,
      photoCredit = _ref.photoCredit,
      className = _ref.className,
      alt = _ref.alt,
      longAlt = _ref.longAlt,
      children = _ref.children,
      width = _ref.width,
      height = _ref.height,
      figStyle = _ref.figStyle,
      imgStyle = _ref.imgStyle,
      capStyle = _ref.capStyle,
      src = _ref.src,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var hasCaption = caption || srCaption || topCaption;

  var cap = caption || topCaption || /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, srCaption);

  var id = (0, _reactUseIdHook.useId)();

  if (!alt && hasCaption && !children) {
    throw new Error("Figures with captions must have a non-empty 'alt' prop.");
  }

  if (!isNaN(width)) {
    width = width + "px";
  }

  if (!isNaN(height)) {
    height = height + "px";
  }

  if (hasCaption === undefined) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "bdg-figure " + (className || ""),
      style: (0, _objectSpread2.default)({
        width: width,
        height: height
      }, figStyle)
    }, src ? /*#__PURE__*/_react.default.createElement(_Image.default, Object.assign({
      alt: alt,
      longAlt: longAlt,
      src: src,
      style: imgStyle
    }, props)) : children, (0, _util.ContentToString)(photoCredit) && /*#__PURE__*/_react.default.createElement("span", {
      className: "photo-credit"
    }, photoCredit));
  }

  return /*#__PURE__*/_react.default.createElement("figure", {
    className: "bdg-figure " + (className || ""),
    style: (0, _objectSpread2.default)({
      width: width,
      height: height
    }, figStyle)
  }, topCaption && /*#__PURE__*/_react.default.createElement("figcaption", {
    id: "figcaption-".concat(id),
    style: capStyle
  }, cap), src ? /*#__PURE__*/_react.default.createElement(_Image.default, Object.assign({
    alt: alt,
    longAlt: longAlt,
    src: src,
    style: imgStyle
  }, props)) : children, (0, _util.ContentToString)(photoCredit) && /*#__PURE__*/_react.default.createElement("span", {
    className: "photo-credit"
  }, photoCredit), !topCaption && /*#__PURE__*/_react.default.createElement("figcaption", {
    id: "figcaption-".concat(id),
    style: capStyle
  }, cap));
}